import { render, staticRenderFns } from "./LsSheetNote.vue?vue&type=template&id=884298ce&scoped=true&"
import script from "./LsSheetNote.vue?vue&type=script&lang=js&"
export * from "./LsSheetNote.vue?vue&type=script&lang=js&"
import style0 from "./LsSheetNote.vue?vue&type=style&index=0&id=884298ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884298ce",
  null
  
)

export default component.exports